/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  display: block;
}

[internal-host] {
  display: flex;
  overflow: visible;
}

::slotted(nve-avatar) {
  margin-inline-start: calc(-1 * var(--nve-ref-size-150));
  --border: 1px solid var(--nve-sys-contrast-mute-color);
}

::slotted(:first-child) {
  margin-inline-start: 0; /* Remove the negative margin for the first slotted nve-avatar */
}
